package pwgs.ui.scenes.acceptinvitationscene

import kotlinx.serialization.Serializable
import visage.rmi.VisageController

@VisageController(AcceptInvitationSceneProps::class, AcceptInvitationSceneModel::class)
interface AcceptInvitation {
    fun load()
}

@Serializable
class AcceptInvitationSceneProps(val invitationId: String)

@Serializable
class AcceptInvitationSceneModel() {
    var isLoading = true
    var isInvitationAccepted = false
}